<div class="eventq-mini-playback-controls" aria-label="Playback controls">
  @if (showSkip()) {
    <button
      type="button"
      class="eventq-mini-playback-controls__skip"
      [disabled]="disabled()"
      [attr.aria-label]="'Skip backward ' + skipSeconds() + ' seconds'"
      (click)="skipBackward.emit()"
    >
      <svg
        class="eventq-mini-playback-controls__skip-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="#B0BEC5"
        aria-hidden="true"
      >
        <path
          d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
        />
        <text
          x="12"
          y="15.2"
          text-anchor="middle"
          fill="#B0BEC5"
          [attr.font-size]="skipGlyphFontSize()"
          font-weight="700"
          font-family="sans-serif"
        >{{ skipSeconds() }}</text>
      </svg>
    </button>
  }
  <button
    type="button"
    class="eventq-mini-playback-controls__play"
    [class.eventq-mini-playback-controls__play--playing]="playing()"
    [disabled]="disabled()"
    [attr.aria-label]="playing() ? 'Pause' : 'Play'"
    (click)="playToggle.emit()"
  >
    @if (playing()) {
      <span class="eventq-mini-playback-controls__pause" aria-hidden="true">
        <span class="eventq-mini-playback-controls__pause-bar"></span>
        <span class="eventq-mini-playback-controls__pause-bar"></span>
      </span>
    } @else if (playIconSrc(); as customPlay) {
      <img [src]="customPlay | prefixUrl" alt="" data-testid="mini-playback-play-icon" />
    } @else {
      <svg
        class="eventq-mini-playback-controls__play-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="#B0BEC5"
        aria-hidden="true"
        data-testid="mini-playback-play-icon"
      >
        <path d="M8 5v14l11-7L8 5z" />
      </svg>
    }
  </button>
  @if (showSkip()) {
    <button
      type="button"
      class="eventq-mini-playback-controls__skip"
      [disabled]="disabled()"
      [attr.aria-label]="'Skip forward ' + skipSeconds() + ' seconds'"
      (click)="skipForward.emit()"
    >
      <svg
        class="eventq-mini-playback-controls__skip-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="#B0BEC5"
        aria-hidden="true"
      >
        <path
          d="M12 5V1l5 5-5 5V7c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6h2c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8z"
        />
        <text
          x="12"
          y="15.2"
          text-anchor="middle"
          fill="#B0BEC5"
          [attr.font-size]="skipGlyphFontSize()"
          font-weight="700"
          font-family="sans-serif"
        >{{ skipSeconds() }}</text>
      </svg>
    </button>
  }
  <span class="eventq-mini-playback-controls__time">{{ elapsedLabel() }}</span>
  <div
    class="eventq-mini-playback-controls__track"
    role="slider"
    tabindex="0"
    [attr.aria-disabled]="disabled() || null"
    [attr.aria-valuemin]="0"
    [attr.aria-valuemax]="100"
    [attr.aria-valuenow]="progress()"
    [attr.aria-label]="'Seek playback'"
    (pointerdown)="onTrackPointerDown($event)"
    (pointermove)="onTrackPointerMove($event)"
    (pointerup)="onTrackPointerUp($event)"
    (pointercancel)="onTrackPointerUp($event)"
  >
    <div
      class="eventq-mini-playback-controls__fill"
      [style.width.%]="progress()"
    ></div>
    @if (scrubberIconSrc(); as customScrubber) {
      <img
        class="eventq-mini-playback-controls__handle"
        [src]="customScrubber | prefixUrl"
        alt=""
        [style.left.%]="progress()"
        data-testid="mini-playback-scrubber"
      />
    } @else {
      <svg
        class="eventq-mini-playback-controls__handle"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
        fill="none"
        aria-hidden="true"
        [style.left.%]="progress()"
        data-testid="mini-playback-scrubber"
      >
        <circle cx="7" cy="7" r="5" fill="#D9D9D9" />
      </svg>
    }
  </div>
  <span class="eventq-mini-playback-controls__time">{{ durationLabel() }}</span>
</div>
